import {useLocalStorage} from '@github-ui/use-safe-storage/local-storage'

import {AGENT_MERGE_ACTIONS, DEFAULT_AGENT_MERGE_ACTION, type AgentMergeAction} from '../page-data/payloads/agent-merge'

export const AGENT_MERGE_ACTION_PREFERENCE_STORAGE_KEY = 'agent-merge:preferred-actions'
export const DEFAULT_AGENT_MERGE_ACTIONS: AgentMergeAction[] = [DEFAULT_AGENT_MERGE_ACTION]

function isAgentMergeActionPreference(value: unknown): value is AgentMergeAction[] {
  return (
    Array.isArray(value) &&
    value.length > 0 &&
    value.every(
      item => typeof item === 'string' && AGENT_MERGE_ACTIONS.some(agentMergeAction => agentMergeAction === item),
    )
  )
}

export function useAgentMergeActionPreference() {
  return useLocalStorage<AgentMergeAction[] | null>(AGENT_MERGE_ACTION_PREFERENCE_STORAGE_KEY, null, {
    validator: isAgentMergeActionPreference,
  })
}
